"use strict";

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _reactDom = require("react-dom");

require("./react-hold-on.css");

var _jquery = require("jquery"),
    _jquery2 = _interopRequireDefault(_jquery),
    _settings = {
  instanceProtection: null
},
    _ = {
  protectInstance: function protectInstance(e) {
    var c = setInterval(function () {
      document.getElementById("holdon-overlay") || _.open(e);
    }, 100);
    _settings.instanceProtection = c;
  },
  getHtml: function getHtml(e, c) {
    switch (e) {
      case "custom":
        return _react2.default.createElement("div", {
          style: "text-align: center;"
        }, [c.content]);

      case "sk-dot":
        return _react2.default.createElement("div", {
          className: "sk-dot"
        }, [_react2.default.createElement("div", {
          className: "sk-dot1"
        }), _react2.default.createElement("div", {
          className: "sk-dot2"
        })]);

      case "sk-rect":
        return _react2.default.createElement("div", {
          className: "sk-rect"
        }, [_react2.default.createElement("div", {
          className: "rect1"
        }), _react2.default.createElement("div", {
          className: "rect2"
        }), _react2.default.createElement("div", {
          className: "rect3"
        }), _react2.default.createElement("div", {
          className: "rect4"
        }), _react2.default.createElement("div", {
          className: "rect5"
        })]);

      case "sk-cube":
        return _react2.default.createElement("div", {
          className: "sk-cube"
        }, [_react2.default.createElement("div", {
          className: "sk-cube1"
        }), _react2.default.createElement("div", {
          className: "sk-cube2"
        })]);

      case "sk-bounce":
        return _react2.default.createElement("div", {
          className: "sk-bounce"
        }, [_react2.default.createElement("div", {
          className: "bounce1"
        }), _react2.default.createElement("div", {
          className: "bounce2"
        }), _react2.default.createElement("div", {
          className: "bounce3"
        })]);

      case "sk-circle":
        return _react2.default.createElement("div", {
          className: "sk-circle"
        }, [_react2.default.createElement("div", {
          className: "sk-circle1 sk-child"
        }), _react2.default.createElement("div", {
          className: "sk-circle2 sk-child"
        }), _react2.default.createElement("div", {
          className: "sk-circle3 sk-child"
        }), _react2.default.createElement("div", {
          className: "sk-circle4 sk-child"
        }), _react2.default.createElement("div", {
          className: "sk-circle5 sk-child"
        }), _react2.default.createElement("div", {
          className: "sk-circle6 sk-child"
        }), _react2.default.createElement("div", {
          className: "sk-circle7 sk-child"
        }), _react2.default.createElement("div", {
          className: "sk-circle8 sk-child"
        }), _react2.default.createElement("div", {
          className: "sk-circle9 sk-child"
        }), _react2.default.createElement("div", {
          className: "sk-circle10 sk-child"
        }), _react2.default.createElement("div", {
          className: "sk-circle11 sk-child"
        }), _react2.default.createElement("div", {
          className: "sk-circle12 sk-child"
        })]);

      case "sk-cube-grid":
        return _react2.default.createElement("div", {
          className: "sk-cube-grid"
        }, [_react2.default.createElement("div", {
          className: "sk-cube-child sk-cube-grid1"
        }), _react2.default.createElement("div", {
          className: "sk-cube-child sk-cube-grid2"
        }), _react2.default.createElement("div", {
          className: "sk-cube-child sk-cube-grid3"
        }), _react2.default.createElement("div", {
          className: "sk-cube-child sk-cube-grid4"
        }), _react2.default.createElement("div", {
          className: "sk-cube-child sk-cube-grid5"
        }), _react2.default.createElement("div", {
          className: "sk-cube-child sk-cube-grid6"
        }), _react2.default.createElement("div", {
          className: "sk-cube-child sk-cube-grid7"
        }), _react2.default.createElement("div", {
          className: "sk-cube-child sk-cube-grid8"
        }), _react2.default.createElement("div", {
          className: "sk-cube-child sk-cube-grid9"
        })]);

      case "sk-folding-cube":
        return _react2.default.createElement("div", {
          className: "sk-folding-cube"
        }, [_react2.default.createElement("div", {
          className: "sk-cubechild1 sk-cube-parent"
        }), _react2.default.createElement("div", {
          className: "sk-cubechild2 sk-cube-parent"
        }), _react2.default.createElement("div", {
          className: "sk-cubechild4 sk-cube-parent"
        }), _react2.default.createElement("div", {
          className: "sk-cubechild3 sk-cube-parent"
        })]);

      case "sk-fading-circle":
        return _react2.default.createElement("div", {
          className: "sk-fading-circle"
        }, [_react2.default.createElement("div", {
          className: "sk-fading-circle1 sk-circle-child"
        }), _react2.default.createElement("div", {
          className: "sk-fading-circle2 sk-circle-child"
        }), _react2.default.createElement("div", {
          className: "sk-fading-circle3 sk-circle-child"
        }), _react2.default.createElement("div", {
          className: "sk-fading-circle4 sk-circle-child"
        }), _react2.default.createElement("div", {
          className: "sk-fading-circle5 sk-circle-child"
        }), _react2.default.createElement("div", {
          className: "sk-fading-circle6 sk-circle-child"
        }), _react2.default.createElement("div", {
          className: "sk-fading-circle7 sk-circle-child"
        }), _react2.default.createElement("div", {
          className: "sk-fading-circle8 sk-circle-child"
        }), _react2.default.createElement("div", {
          className: "sk-fading-circle9 sk-circle-child"
        }), _react2.default.createElement("div", {
          className: "sk-fading-circle10 sk-circle-child"
        }), _react2.default.createElement("div", {
          className: "sk-fading-circle11 sk-circle-child"
        }), _react2.default.createElement("div", {
          className: "sk-fading-circle12 sk-circle-child"
        })]);

      default:
        return console.warn(e + " doesn't exist for React HoldOn"), _react2.default.createElement("div", {
          className: "sk-rect"
        }, [_react2.default.createElement("div", {
          className: "rect1"
        }), _react2.default.createElement("div", {
          className: "rect2"
        }), _react2.default.createElement("div", {
          className: "rect3"
        }), _react2.default.createElement("div", {
          className: "rect4"
        }), _react2.default.createElement("div", {
          className: "rect5"
        })]);
    }
  },
  open: function open(e) {
    var c = "sk-rect",
        t = "",
        a = "",
        l = {
      display: "none"
    };
    e && (e.hasOwnProperty("theme") && (c = e.theme), e.hasOwnProperty("message") && (a = e.message)), t = _.getHtml(c, e);

    var r = _react2.default.createElement("div", {
      id: "holdon-content-container"
    }, [_react2.default.createElement("div", {
      id: "holdon-content"
    }, [t]), _react2.default.createElement("div", {
      id: "holdon-message"
    }, [a])]);

    clearInterval(_settings.instanceProtection), _.removeOverlay();
    var s = document.createElement("div");
    return s.id = "holdon-overlay", s.style = l, document.getElementById("holdon-overlay") || document.body.appendChild(s), (0, _reactDom.render)(r, document.getElementById("holdon-overlay")), (0, _jquery2.default)(document.getElementById("holdon-overlay")).fadeIn(), e && (e.backgroundColor && (l.backgroundColor = e.backgroundColor), e.color && (l.color = e.color), _.protectInstance(e)), !0;
  },
  removeOverlay: function removeOverlay() {
    var e = document.getElementById("holdon-overlay");
    (0, _jquery2.default)(e).fadeOut(400, function () {
      e && e.parentNode && e.parentNode.removeChild(e);
    });
  },
  close: function close() {
    return !!document.getElementById("holdon-overlay") && (clearInterval(_settings.instanceProtection), _.removeOverlay(), _settings.instanceProtection = null, !0);
  }
};

exports.default = _;